import type { AppLifecycleState, AppStatePort } from "../../ports/app-state.port";

// @capacitor/app appStateChange адаптер.
export const appStateCapacitorAdapter: AppStatePort = {
	onForeground(handler) {
		let cleanup: (() => void) | undefined;
		import("@capacitor/app").then(({ App }) => {
			const sub = App.addListener("appStateChange", (state) => {
				if (state.isActive) handler();
			});
			cleanup = () => {
				sub.then((s) => s.remove());
			};
		});
		return () => cleanup?.();
	},
	onBackground(handler) {
		let cleanup: (() => void) | undefined;
		import("@capacitor/app").then(({ App }) => {
			const sub = App.addListener("appStateChange", (state) => {
				if (!state.isActive) handler();
			});
			cleanup = () => {
				sub.then((s) => s.remove());
			};
		});
		return () => cleanup?.();
	},
	async getState(): Promise<AppLifecycleState> {
		const { App } = await import("@capacitor/app");
		const state = await App.getState();
		return state.isActive ? "foreground" : "background";
	},
};
